import { render, staticRenderFns } from "./ElementAlert.vue?vue&type=template&id=16549b40&scoped=true"
import script from "./ElementAlert.vue?vue&type=script&lang=js"
export * from "./ElementAlert.vue?vue&type=script&lang=js"
import style0 from "./ElementAlert.vue?vue&type=style&index=0&id=16549b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16549b40",
  null
  
)

export default component.exports